import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (rows, columns, fileName) => {
  // Map column headers to an array of objects representing the sheet data
  const sheetData = rows.map((row) => {
    const rowData = {};
    columns.forEach((col) => {
        rowData[col.headerName] = row[col.field];
    });
    return rowData;
  });

  // Create a worksheet from the data
  const worksheet = XLSX.utils.json_to_sheet(sheetData);

  // Create a workbook and add the worksheet
  const workbook = {
    Sheets: { data: worksheet },
    SheetNames: ["data"],
  };

  // Generate Excel file buffer
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Save the file
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, `${fileName}.xlsx`);
};
